/**
 * StatusDot — indicador visual de status de execução Nava.
 *
 * Extraído do protótipo sem alteração visual.
 * Statuses suportados: running | gate-waiting | completed | failed | pending
 *
 * Acessibilidade: role="status" + aria-label com o texto do label.
 */
import { C } from '@/theme/palette';

// Lido a cada render (o tema pode mudar). Aprovação = âmbar (contrato Sphere).
function statusMap() {
  return {
    running:       { color: C.digital,     label: 'EM EXECUÇÃO',        pulse: true  },
    'gate-waiting':{ color: C.warn,        label: 'AGUARDANDO GATE',    pulse: true  },
    completed:     { color: C.cyber,       label: 'CONCLUÍDO',          pulse: false },
    failed:        { color: C.hot,         label: 'FALHOU',             pulse: false },
    pending:       { color: C.neutralMuted,label: 'PENDENTE',           pulse: false },
  };
}

export function StatusDot({ status }) {
  const map = statusMap();
  const s = map[status] ?? map.pending;

  return (
    <div
      className="flex items-center gap-2"
      role="status"
      aria-label={s.label}
    >
      <span
        aria-hidden="true"
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: s.color,
          boxShadow: s.pulse ? `0 0 0 0 ${s.color}55` : 'none',
          animation: s.pulse ? 'navaPulse 2s ease-out infinite' : 'none',
          flexShrink: 0,
        }}
      />
      <span
        style={{
          color: s.color,
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '0.04em',
        }}
      >
        {s.label}
      </span>
    </div>
  );
}
